<template>
    <div class="goods-order">
        <div class="goods-order-title">确认订单</div>
        <div class="goods-order-content">
            <!-- 除了v卡外订单，有提示 -->
            <div
                v-if="
                    goodsList.goodsId !== '6' &&
                        goodsList.goodsId !== '8' &&
                        goodsList.goodsId !== '1000' &&
                        goodsList.goodsId !== '2000'
                "
                class="goods-order-warning"
            >
                <veui-icon
                    class="goods-order-warning-icon"
                    name="exclamation-circle-solid"
                />
                <span>{{ showTxt.warining }}</span>
            </div>
            <div
                v-for="(item, index) in showTxt.orderMap"
                :key="index"
            >
                <div
                    v-if="goodsOrder[item.key] !== 'hidden'"
                    :key="index"
                    class="goods-order-row"
                >
                    <div class="goods-order-row-label">{{ item.label }}</div>
                    <div
                        v-if="item.key !== 'payAmount'"
                        class="goods-order-row-info"
                        :class="{
                            'goods-order-row-info-orange':
                                item.key === 'discountAmountTxt',
                        }"
                    >
                        {{ goodsOrder[item.key] }}
                        <span v-if="item.tip" class="goods-order-row-tip">{{
                            item.tip
                        }}</span>
                    </div>
                    <div
                        v-else
                        class="goods-order-row-info goods-order-row-price"
                    >
                        <template v-if="goodsList.goodsId === '5'">
                            <span
                                class="goods-order-row-info-count"
                            >共{{ goodsOrder.count }}个，¥</span>
                            <span class="goods-order-row-info-pay">{{
                                goodsOrder.total_price / 100
                            }}</span>
                        </template>
                        <template v-else-if="goodsList.goodsId === '6'">
                            <span
                                class="goods-order-row-info-count"
                            >共{{ goodsOrder.num }}个律临V卡，¥
                            </span>
                            <span class="goods-order-row-info-pay">{{
                                goodsOrder.pay_amount / 100
                            }}</span>
                        </template>
                        <template v-else-if="goodsList.goodsId === '3'">
                            <span
                                class="goods-order-row-info-count"
                            >共{{ goodsOrder.num }}个律临会员，{{
                                goodsOrder.domainFieldsNum
                            }}个plus服务，¥
                            </span>
                            <span class="goods-order-row-info-pay">{{
                                goodsOrder.pay_amount / 100
                            }}</span>
                        </template>
                        <template v-else-if="goodsList.goodsId === '2000'">
                            <span
                                class="goods-order-row-info-count"
                            >共{{ goodsOrder.num }}个启航会员，¥
                            </span>
                            <span class="goods-order-row-info-pay">{{
                                goodsOrder.pay_amount / 100
                            }}</span>
                        </template>
                        <template v-else-if="+goodsList.goodsId === 2001">
                            <span
                                class="goods-order-row-info-count"
                            >共{{ goodsOrder.num }}个精英会员，¥
                            </span>
                            <span class="goods-order-row-info-pay">{{
                                goodsOrder.pay_amount / 100
                            }}</span>
                        </template>
                        <template v-else>
                            <span
                                class="goods-order-row-info-count"
                            >共{{ goodsOrder.num }}个至尊会员，<span>{{
                                goodsOrder.domainFieldsNum
                            }}个plus服务，</span>¥
                            </span>
                            <span class="goods-order-row-info-pay">{{
                                goodsOrder.pay_amount / 100
                            }}</span>
                        </template>
                    </div>
                </div>
                <!-- 律临、律所会员，购买年限行下，增加plus信息-新样式 -->
                <div
                    v-if="showTxt.isLvlinMember && item.key === 'range'"
                    class="goods-order-plus"
                >
                    <div
                        v-if="goodsOrder.servicePrice"
                        class="goods-order-plus-price"
                    >
                        <span class="goods-order-plus-price-desc">Plus服务</span>
                        <span class="goods-order-plus-price-num">(领域标签{{ goodsOrder.servicePrice }}/年)</span>
                    </div>
                    <div
                        v-if="goodsOrder.domainFieldsNumTxt"
                        class="goods-order-plus-tag"
                    >
                        标签数量<span class="goods-order-plus-tag-num">{{ goodsOrder.domainFieldsNumTxt }}</span>
                    </div>
                </div>
            </div>
            <div
                v-if="
                    goodsOrder.count && goodsOrder.count < goodsForm.clue_count
                "
                class="goods-order-tip"
            >
                系统检测到你所选择的线索有{{ goodsOrder.count }}条
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 线索购买
 * @author
 */
import {Icon} from 'veui';
import 'veui-theme-dls-icons/exclamation-circle-solid';
const orderMapClue = [
    {label: '线索领域', key: 'clue_territory'},
    {label: '线索地域', key: 'clue_city'},
    {label: '线索时效', key: 'day_range'},
    {label: '合计支付', key: 'payAmount'}
];
const orderMapMmber = [
    {label: '购买商品', key: 'name'},
    {label: '购买年限', key: 'range'},
    {label: '购买数量', key: 'numTxt'},
    // {label: '会员单价', key: 'priceText'},
    // {label: 'plus服务', key: 'plusService'},
    // {label: '购买数量', key: 'domainFieldsNumTxt'},
    // {label: '服务单价', key: 'servicePrice'},
    {label: '共计优惠', key: 'discountAmountTxt'},
    {label: '合计支付', key: 'payAmount'}
];
const orderMapLight = [
    {label: '购买商品', key: 'name'},
    {label: '购买年限', key: 'range'},
    {label: '购买数量', key: 'numTxt'},
    {label: '共计优惠', key: 'discountAmountTxt'},
    {label: '合计支付', key: 'payAmount'}
];
const orderExposoure = [
    {label: '目标城市', key: 'city'},
    {label: '目标律师', key: 'lawyer'},
    {label: '目标领域', key: 'domain'},
    {label: '投放日期', key: 'range'},
    {label: '单价', key: 'servicePrice'},
    {label: '应付金额', key: 'totalAmount'},
    {label: '优惠金额', key: 'discountAmount'},
    {label: '实付金额', key: 'shouldPayAmount'}
];
const orderMapAddClue = [
    {label: '购买商品', key: 'name'},
    {label: '目标律师', key: 'lawyer'},
    {label: '执业证号', key: 'qcCoreNo', tip: '（后六位）'},
    {label: '线索单价', key: 'price'},
    {label: '线索总价', key: 'shouldPayAmount'}
];
const orderMapYoung = [
    {label: '购买商品', key: 'name'},
    {label: '购买年限', key: 'range'},
    {label: '购买数量', key: 'numTxt'},
    {label: '共计优惠', key: 'discountAmountTxt'},
    {label: '合计支付', key: 'payAmount'}
];
export default {
    name: 'goodsForm',
    components: {
        'veui-icon': Icon
    },
    props: {
        goodsList: {
            type: Object,
            default: () => {}
        },
        goodsForm: {
            type: Object,
            default: () => {}
        },
        goodsOrder: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        showTxt() {
            if (
                +this.goodsList.goodsId === 3
                || +this.goodsList.goodsId === 7
                || +this.goodsList.goodsId === 2001
            ) {
                return {
                    isLvlinMember: true,
                    orderMap: orderMapMmber,
                    warining:
                        'plus服务：领域标签与购买验证码绑定，一旦操作绑定验证码，则领域标签与验证码均不支持平台退款，请谨慎购买。'
                };
            }
            else if (+this.goodsList.goodsId === 6) {
                return {
                    orderMap: orderMapLight
                };
            }
            else if (+this.goodsList.goodsId === 8) {
                return {
                    orderMap: orderExposoure
                };
            }
            else if (+this.goodsList.goodsId === 1000) {
                return {
                    orderMap: orderMapAddClue
                };
            }
            else if (+this.goodsList.goodsId === 2000) {
                return {
                    orderMap: orderMapYoung
                };
            }
            return {
                orderMap: orderMapClue,
                warining: '线索一旦购买，不可退款不可撤销，请谨慎操作！'
            };
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>

<style scoped lang="less">
.goods-order {
    &-title {
        height: 28px;
        line-height: 28px;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #000;
        font-weight: 600;
    }

    &-content {
        margin-top: 16px;
    }

    &-warning {
        width: fit-content;
        height: 33px;
        line-height: 33px;
        background: #f0f6ff;
        border-radius: 4px;
        padding: 0 21px 0 16px;
        margin-left: 24px;

        .goods-order-warning-icon {
            color: #0052cd;
            font-size: 16px;
            vertical-align: text-top;
            margin-right: 4px;
        }
    }

    &-row {
        display: flex;
        height: 20px;
        font-size: 14px;
        margin-top: 16px;
        align-items: flex-end;

        &-label {
            margin-left: 24px;
            width: 56px;
            color: #000;
        }

        &-info {
            color: #282c33;
            margin-left: 12px;

            .goods-order-row-tip {
                color: #999;
            }
        }

        &-price {
            display: flex;
            align-items: flex-end;
        }

        .goods-order-row-info-pay {
            font-size: 24px;
            line-height: 24px;
            margin-left: 3px;
        }

        .goods-order-row-info-orange {
            color: #ff9100;
        }
    }

    &-plus {
        width: 240px;
        padding: 12px;
        margin-top: 15px;
        margin-left: 90px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #848b99;
        line-height: 20px;
        font-weight: 400;
        background: #f7f8fa;
        border-radius: 8px;
        box-sizing: border-box;

        &-price {
            margin-bottom: 8px;

            &-desc {
                font-family: PingFangSC-Medium;
                color: #000;
                font-weight: 500;
            }

            &-num {
                font-family: PingFangSC-Regular;
                color: #848b99;
                font-weight: 400;
                margin-left: 4px;
            }
        }

        &-tag {
            &-num {
                margin-left: 12px;
            }
        }
    }

    &-tip {
        width: fit-content;
        height: 38px;
        line-height: 38px;
        text-align: center;
        padding: 0 12px;
        background: #f9f9f9;
        margin-top: 21px;
        margin-left: 98px;
    }
}
</style>
